import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglestreetviewComponent } from './simple-icons-googlestreetview.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglestreetviewComponent ],
    exports:      [ SimpleIconsGooglestreetviewComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglestreetviewModule {}
